import { useEffect, useState } from "react"
import { DetailPage, Row } from "../../components/crud/DetailPage"
import { Badge, FkLink, ListPage } from "../../components/crud/ListPage"
import { AsyncSelect, Checkbox, DateInput, NumberInput, Select } from "../../components/forms/Inputs"
import { useApi } from "../../hooks/useApi"
import { useOptions } from "../../hooks/useOptions"
import { useToday } from "../../hooks/useToday"
import { useTranslations } from "../../layers/Localization"
import { useAVerifierOptions } from "./Factures"
import { FacturesAchatDetailsList } from "./FacturesAchatDetail"
import { Popup } from "../../components/layout/Popup"
import { Form } from "../../components/forms/Form"
import { Button } from "../../components/layout/Button"
import { FaBan, FaSave } from "react-icons/fa"
import { useObjectState } from "../../hooks/useObjectState"
import { Currency } from "../../hooks/helpers"
import { useParams } from "react-router-dom"
import { useCodesTvaOptions } from "./Articles"
import { getTotalsFactureDetail } from "./FacturesDetail"

export function useMoisOptions() {
    const t = useTranslations()
    return [
        { value: 1, label: t('Janvier') },
        { value: 2, label: t('Février') },
        { value: 3, label: t('Mars') },
        { value: 4, label: t('Avril') },
        { value: 5, label: t('Mai') },
        { value: 6, label: t('Juin') },
        { value: 7, label: t('Juillet') },
        { value: 8, label: t('Août') },
        { value: 9, label: t('Septembre') },
        { value: 10, label: t('Octobre') },
        { value: 11, label: t('Novembre') },
        { value: 12, label: t('Décembre') },
    ]
}

function FacturesAchatFields({ item, set }) {
    const [details, setDetails] = useState([])
    const codesTvaOptions = useCodesTvaOptions()

    const t = useTranslations()
    const fournisseurOptions = useOptions('fournisseurs', 'nom')
    const { id } = useParams()
    const api = useApi()

    useEffect(() => {
        if (id !== 'new') {
            api.get(`/facturesAchatDetail?factureAchatId=${encodeURIComponent(id)}&limit=100`).then(setDetails)
        }
    }, [id])

    return <>
        <Checkbox label={t("A vérifier")} value={item.aVerifier} onChange={set('aVerifier')} />
        <Checkbox label={t("Encodée en comptabilité")} value={item.comptabilite} onChange={set('comptabilite')} />
        <Row>
            <NumberInput label={t("Exercice")} value={item.exercice} onChange={set('exercice')} required disabled={item.comptabilite} />
            <DateInput label={t("Date")} value={item.date} onChange={set('date')} required disabled={item.comptabilite} />
            <AsyncSelect className="grow" label={t("Fournisseur")} value={item.fournisseurId} onChange={set('fournisseurId')} options={fournisseurOptions} disabled={item.comptabilite} />
        </Row>
        {(!!details.length) && <div className="flex">
            <div className={`grid grid-cols-[repeat(6,auto)] gap-x-8 gap-y-3 mt-5 whitespace-nowrap overflow-auto ${item.comptabilite ? 'opacity-50' : ''}`}>
                <div></div>
                <div className="font-bold">0%</div>
                <div className="font-bold">6%</div>
                <div className="font-bold">21%</div>
                <div className="font-bold">20 bis</div>
                <div className="font-bold">{t("Totaux:")}</div>
                <div className="font-bold">{t("Bases:")}</div>
                <Currency value={details.filter(x => x.codeTva === 'ZERO').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalHtva, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'SIX').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalHtva, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'VINGT_ET_UN').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalHtva, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'VINGT_BIS').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalHtva, 0)} />
                <Currency value={details.reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalHtva, 0)} />
                <div className="font-bold">{t("TVA:")}</div>
                <Currency value={details.filter(x => x.codeTva === 'ZERO').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTva, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'SIX').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTva, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'VINGT_ET_UN').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTva, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'VINGT_BIS').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTva, 0)} />
                <Currency value={details.reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTva, 0)} />
                <div className="font-bold">{t("Total:")}</div>
                <Currency value={details.filter(x => x.codeTva === 'ZERO').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTtc, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'SIX').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTtc, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'VINGT_ET_UN').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTtc, 0)} />
                <Currency value={details.filter(x => x.codeTva === 'VINGT_BIS').reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTtc, 0)} />
                <Currency value={details.reduce((total, x) => total + getTotalsFactureDetail(x, codesTvaOptions).totalTtc, 0)} />
            </div>
        </div>}
    </>
}

export function FacturesAchatList(props) {
    const [generatePopup, setGeneratePopup] = useState(false)

    const t = useTranslations()
    const aVerifierOptions = useAVerifierOptions()
    const api = useApi()

    return <>
        <ListPage model="facturesAchat" title={t("Factures sous-traitant")} columns={{
            [t('Exercice')]: 'exercice',
            [t('Date')]: 'date',
            [t('Fournisseur')]: { sort: 'fournisseur', value: item => <FkLink>{item.fournisseur?.nom}</FkLink> },
            [t('Status')]: { sort: 'aVerifier', value: item => <Badge value={item?.aVerifier} options={aVerifierOptions} /> },
        }} join={{
            fournisseur: 'nom',
        }} sort={tab => tab === t('Factures à recevoir')
            ? { [t('Status')]: 'desc', [t('Exercice')]: 'desc', [t('Date')]: 'desc' }
            : { [t('Exercice')]: 'desc', [t('Date')]: 'desc' }
        } filter={{
            [t('Factures à recevoir')]: 'comptabilite=false',
            [t('Factures reçues et encodées')]: `comptabilite=true`,
        }} mainActions={{
            [t('Supprimer factures automatiques')]: reload => api.post('/facturesAchat/delete-generated-draft').then(reload),
            [t('Générer factures automatiques')]: reload => setGeneratePopup(true),
        }} {...props} />
        <GeneratePopup value={generatePopup} onChange={setGeneratePopup} />
    </>
}

export function FacturesAchatDetail(props) {
    const t = useTranslations()
    const today = useToday()

    return <DetailPage model="facturesAchat" title={t("Facture sous-traitant")} Fields={FacturesAchatFields} defaults={{
        exercice: today.getFullYear(),
    }} tables={{
        [t('Details')]: <FacturesAchatDetailsList relation="factureAchatId" root="." />
    }} {...props} />
}

function GeneratePopup({ value, onChange }) {
    const t = useTranslations()
    const defaultPayload = {
        year: new Date().getUTCFullYear(),
        month: new Date().getUTCMonth() + 1,
    }
    const [payload, setPayload, set] = useObjectState(defaultPayload)
    const api = useApi()
    const moisOptions = useMoisOptions()

    const generate = async () => {
        const actionPayload = payload
        closePopup()
        await api.post(`/facturesAchat/generate-draft`, actionPayload)
        window.location.reload()
    }

    const closePopup = () => {
        onChange(null)
        setPayload(defaultPayload)
    }

    return <Popup value={!!value} onChange={value => onChange(value)}>
        <h2 className="font-bold text-lg mb-3">{t('Générer factures')}</h2>
        <Form onSubmit={generate} className="flex flex-col gap-3">
            <Row>
                <NumberInput label={t('Année')} value={payload.year} onChange={set('year')} required />
                <Select label={t('Mois')} value={payload.month} onChange={set('month')} required options={moisOptions} />
            </Row>
            <Row className="mt-5">
                <Button gray icon={<FaBan />} onClick={closePopup}>{t('Cancel')}</Button>
                <Button submit icon={<FaSave />}>{t('Save')}</Button>
            </Row>
        </Form>
    </Popup>
}